import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { IconButton, Paper, TextField } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { HighlightOff } from '@material-ui/icons';

const useStyles = makeStyles((theme) => ({
  paper: {
    width: '100%',
    minWidth: '435px',
    maxWidth: '650px',
    height: '156px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: theme.spacing(2, 4),
    gap: theme.spacing(6),
    boxShadow:
      '2px 2px 1px 0px rgba(0, 0, 0, 0.2), 0px 1px 1px 2px rgba(0,0,0,0.14), 0px 1px 1px 0px rgba(0,0,0,0.12)',
  },
  contentWrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'center',
    flex: '1 1 auto',
    gap: theme.spacing(1),
    overflow: 'auto',
  },
  imageWrapper: {
    height: 144,
  },
  img: {
    maxWidth: '100%',
    maxHeight: '100%',
  },
}));

const ImageCard = ({
  image,
  index,
  onChangeField,
  onRemoveAttachment,
  urlPath,
}) => {
  const URL = process.env.REACT_APP_BACKEND_ENDPOINT;
  const classes = useStyles();

  const [titolo, setTitolo] = useState(image.titolo || '');
  const [note, setNote] = useState(image.note || '');

  return (
    <Paper className={classes.paper}>
      <div className={classes.imageWrapper}>
        <img
          className={classes.img}
          alt="Placeholder"
          src={`${URL}${urlPath}${image.id}`}
        />
      </div>

      <div className={classes.contentWrapper}>
        <TextField
          fullWidth
          label="Titolo"
          value={titolo}
          name="titolo"
          multiline
          rowsMax={2}
          onChange={(e) => setTitolo(e.target.value)}
          onBlur={() => onChangeField(titolo, index, 'titolo')}
        />
        <TextField
          fullWidth
          label="Note"
          value={note}
          name="note"
          multiline
          rowsMax={2}
          onChange={(e) => setNote(e.target.value)}
          onBlur={() => onChangeField(note, index, 'note')}
        />
      </div>

      <div>
        <IconButton
          color="primary"
          size="small"
          aria-label="Rimuovi allegato"
          onClick={() => onRemoveAttachment(image.id)}
        >
          <HighlightOff />
        </IconButton>
      </div>
    </Paper>
  );
};

ImageCard.propTypes = {
  image: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
  onChangeField: PropTypes.func.isRequired,
  onRemoveAttachment: PropTypes.func.isRequired,
  urlPath: PropTypes.string.isRequired,
};

export default ImageCard;
